import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  utilityId: 1,
  applicationTypeId: 10,
  consumerNumber: "",
  consumerName: "",
  tariffName: "",
  applicant: {
    applicantTypeId: "",
    occupancyTypeId: "",
    panNumber: "",
    gstNumber: "",
  },
  authorizedPerson: {
    isAuthorizedPerson: "",
    id: 0,
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    designation: "",
    email: "",
    mobileNumber: "",
    landLine: "",
  },
  connectionLoad: {
    id: 0,
    powerRequirementUnit: "",
    powerRequirement: "",
  },
  utilityAddress: {
    id: 0,
    premiseTypeId: "",
    premiseUsagePurpose: "",
    premisesAreaId: "",
    zoneId: "",
    blockId: "",
    roadId: "",
    buildingId: "",
    floors: [],
    unitName: "",
    nearestLandmark: "",
    isBPL: "",
    // isRural: "",
    otherZone: "",
    otherBlock: "",
    otherBuilding: "",
    otherRoad: "",
  },
  solar: {
    id: 0,
    utilityAddressId: "",
    developerName: "",
    gEDANumber: "",
    cEIApprovalNumber: "",
    capacity: "",
    capacityUnit: "",
    proposedDate: "",
    type: "",
    endUse: "",
    isRegisteredREC: false,
    energySettlement: "",
    existingSolarCapacity: "",
    otherPowerCapacity: "",
    openAccess: "",
  },
  declaration: {
    declarationId: 0,
    consumerDuesOutstanding: "",
    premisesDuesOutstanding: "",
    firmDuesOutstanding: "",
  },
  documents: [],
};

const netMeteringSlice = createSlice({
  name: "netMeteringSliceFormData",
  initialState,
  reducers: {
    setValues(_, action) {
      return action.payload;
    },
    resetValues() {
      return initialState;
    },
  },
});

export const { setValues, resetValues } = netMeteringSlice.actions;

export default netMeteringSlice.reducer;
